import PropTypes from 'prop-types';
import React, { Component } from 'react';
import errorMessages from 'constants/errorMessages';

export default class Warning extends Component {
  static propTypes = {
    message: PropTypes.string,
    style: PropTypes.object,
  };
  static defaultProps = {
    message: errorMessages.defaultServerError,
  };

  render() {
    const { message, style } = this.props;

    return (
      <div className="link link_attention-red page_margin30" style={style}>
        {message}
      </div>
    );
  }
}
